export const config = {
  basepath: ''
}
